

















    import Vue, { PropOptions } from 'Vue';
    import Vuex from 'Vuex';
    import Vuetify from 'Vuetify';
    import VueRoute from 'Vue-Router';
    
    export default Vue.extend({
        name:'application-panel-content',
        props: {
            title: { type: String, required: false } as PropOptions<string>,
            colour: { type: String, requied: false } as PropOptions<string>,
            dark: { type: Boolean, required: false, default:false } as PropOptions<boolean>,
            dense: { type: Boolean, required: false } as PropOptions<boolean>,
            containerClasses: { type: String, required: false } as PropOptions<string>,
            contentClasses: { type: String, required: false } as PropOptions<string>
        },
        computed: {
            contentCss(): string {
                return `panelContent fullHeight ${this.contentClasses}`;
            },
            containerCss(): string {
                return `pa-0 ${this.containerClasses}`;
            },
            calcWidth(): string {
                var width = '';
                if (this.$root.$vuetify.breakpoint.smAndDown) {
                    width = `width:${this.$vuetify.breakpoint.width * 0.9}px;`;
                }
                return width;
            },
            calcHeight(): string {
                return `height:calc(100% - ${this.$vuetify.application.top}px);`;
            },
            textColourCss(): string {
                return this.$store.getters['textCssClass'];
            },
            isMobile(): boolean {
                return this.$vuetify.breakpoint.mobile;
            }
        },
        methods: {
            closeClickHandler(): void {
                this.$router.replace({ path:'/' });
                this.$store.commit('ui/setAppPanelVisible', false);
            }
        }
    });
